var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { FC, useState, useMemo } from "react";
import { Input } from '@brg/input';
import { Button, FlexBox, Fonts, useBreakpoint, useToasts } from '@brg/ui';
import { ComplaintAPI } from '@brg/api';
import styled, { useTheme } from 'styled-components';
import useLocalization from "../../../hooks/useLocalization";
import { ApplicationShared, useAssociatedProfile } from "@brg/auth";
import { UInput } from "../../inputs";
import { LayoutConst } from "../../../core/modules/layout.module";
export var ReportWrapper = styled(FlexBox)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    width: 564px;\n    margin: 0 auto 134px auto;\n    justify-content: space-between;\n\n  @media (max-width: ", "px) {\n    width: calc(100% - 72px);\n    margin: 64px 36px 0;\n  }\n  @media (max-width: ", "px) {\n    width: calc(100% - 32px);\n    margin: 32px 16px 0;\n  }\n"], ["\n    width: 564px;\n    margin: 0 auto 134px auto;\n    justify-content: space-between;\n\n  @media (max-width: ", "px) {\n    width: calc(100% - 72px);\n    margin: 64px 36px 0;\n  }\n  @media (max-width: ", "px) {\n    width: calc(100% - 32px);\n    margin: 32px 16px 0;\n  }\n"])), LayoutConst.screen.md, LayoutConst.screen.s);
export var ButtonWrapper = styled(FlexBox)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\n  @media (max-width: ", "px) {\n    width: 100%;\n  }\n  \n  @media (max-width: ", "px) {\n    position: absolute;\n    bottom: 16px;\n  }\n"], ["\n\n  @media (max-width: ", "px) {\n    width: 100%;\n  }\n  \n  @media (max-width: ", "px) {\n    position: absolute;\n    bottom: 16px;\n  }\n"])), LayoutConst.screen.md, LayoutConst.screen.s);
export var ReportTitle = styled(FlexBox)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    ", ";\n    color: ", ";\n"], ["\n    ", ";\n    color: ", ";\n"])), Fonts.Inter.sectionTitle, function (p) { return p.theme.reportFormWhite.text; });
export var ReportFieldLabel = styled(FlexBox)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    ", ";\n    font-size: 17px;\n    line-height: 22px;\n    letter-spacing: -0.02em;\n    color: ", ";\n    font-weight: 400;\n  \n    @media (max-width: ", "px) {\n      font-size: 13px;\n      line-height: 16px;\n      letter-spacing: normal;\n    }\n"], ["\n    ", ";\n    font-size: 17px;\n    line-height: 22px;\n    letter-spacing: -0.02em;\n    color: ", ";\n    font-weight: 400;\n  \n    @media (max-width: ", "px) {\n      font-size: 13px;\n      line-height: 16px;\n      letter-spacing: normal;\n    }\n"])), Fonts.Inter.smallText, function (p) { return p.theme.reportFormWhite.text; }, LayoutConst.screen.s);
var ReportButton = styled(Button.YellowMedium)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  \n    background: ", "!important;\n    color: ", "!important;\n    border: none!important;\n    border-radius: 3px!important;\n  \n    &:disabled {\n      background: ", "!important;\n      color: ", "!important;\n      border: none!important;\n    }\n\n  @media (max-width: ", "px) {\n    width: calc(100vw - 32px);\n  }\n"], ["\n  \n    background: ", "!important;\n    color: ", "!important;\n    border: none!important;\n    border-radius: 3px!important;\n  \n    &:disabled {\n      background: ", "!important;\n      color: ", "!important;\n      border: none!important;\n    }\n\n  @media (max-width: ", "px) {\n    width: calc(100vw - 32px);\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.reportFormWhite.btns.submit.bg;
}, function (_a) {
    var theme = _a.theme;
    return theme.reportFormWhite.btns.submit.color;
}, function (_a) {
    var theme = _a.theme;
    return theme.reportFormWhite.btns.submit.disabledBg;
}, function (_a) {
    var theme = _a.theme;
    return theme.reportFormWhite.btns.submit.disabledColor;
}, LayoutConst.screen.s);
var ReportTextarea = styled(Input.Textarea)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  background-color: ", ";\n  border-color: ", ";\n  border: none!important;\n  color: ", ";\n  height: 200px!important;\n  \n  &:focus {\n    border: none!important;\n  }\n\n  ::-webkit-scrollbar {\n    width: 3px; /* \u0448\u0438\u0440\u0438\u043D\u0430 scrollbar */\n    height: 3px;\n  }\n  ::-webkit-scrollbar-track {\n    background: ", "; /* \u0446\u0432\u0435\u0442 \u0434\u043E\u0440\u043E\u0436\u043A\u0438 */\n  }\n  ::-webkit-scrollbar-thumb {\n    border-radius: 310px; /* \u0437\u0430\u043A\u0440\u0443\u0433\u043B\u0435\u043D\u0438\u044F \u043F\u043B\u0430\u0448\u043A\u0438 */\n    background: ", ";\n  }\n"], ["\n  background-color: ", ";\n  border-color: ", ";\n  border: none!important;\n  color: ", ";\n  height: 200px!important;\n  \n  &:focus {\n    border: none!important;\n  }\n\n  ::-webkit-scrollbar {\n    width: 3px; /* \u0448\u0438\u0440\u0438\u043D\u0430 scrollbar */\n    height: 3px;\n  }\n  ::-webkit-scrollbar-track {\n    background: ", "; /* \u0446\u0432\u0435\u0442 \u0434\u043E\u0440\u043E\u0436\u043A\u0438 */\n  }\n  ::-webkit-scrollbar-thumb {\n    border-radius: 310px; /* \u0437\u0430\u043A\u0440\u0443\u0433\u043B\u0435\u043D\u0438\u044F \u043F\u043B\u0430\u0448\u043A\u0438 */\n    background: ", ";\n  }\n"
    /**
     * **ReportForm** - форма отправки жалобы
     *
     * @param props
     */
])), function (_a) {
    var theme = _a.theme;
    return theme.reportFormWhite.inputs.backgroundColor;
}, function (_a) {
    var theme = _a.theme;
    return theme.reportFormWhite.inputs.borderColor;
}, function (_a) {
    var theme = _a.theme;
    return theme.reportFormWhite.inputs.color;
}, function (_a) {
    var theme = _a.theme;
    return theme.reportFormWhite.inputs.backgroundColor;
}, function (_a) {
    var theme = _a.theme;
    return theme.reportFormWhite.scroll;
});
/**
 * **ReportForm** - форма отправки жалобы
 *
 * @param props
 */
export var ReportForm = function (props) {
    var t = useLocalization().t;
    var theme = useTheme();
    var handleClose = props.handleClose, entityId = props.entityId, entityType = props.entityType;
    var _a = useState(-1), reasonType = _a[0], setReasonType = _a[1];
    var _b = useState(""), comment = _b[0], setComment = _b[1];
    var _c = useState(false), disabled = _c[0], setDisabled = _c[1];
    var profile = useAssociatedProfile();
    var is744BP = useBreakpoint(LayoutConst.screen.s);
    var toasts = useToasts();
    var onClickHandler = function (ev) { return __awaiter(void 0, void 0, void 0, function () {
        var error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (reasonType < 0 || reasonType > 13)
                        return [2 /*return*/];
                    setDisabled(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, ComplaintAPI.DoReport({
                            authorId: profile === null || profile === void 0 ? void 0 : profile.accountId,
                            target: {
                                entityId: entityId,
                                entityType: entityType,
                                service: ApplicationShared.application,
                            },
                            info: comment,
                            reason: reasonType
                        })];
                case 2:
                    _a.sent();
                    toasts.info(t('reports.report_success'));
                    if (handleClose)
                        handleClose();
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _a.sent();
                    toasts.error(t('reports.report_error'));
                    console.error(error_1);
                    setDisabled(false);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var custom = useMemo(function () { return ({
        customTextColor: theme.reportFormWhite.text,
        customPlaceholderColor: theme.reportFormWhite.text,
        customBackgroundColor: theme.reportFormWhite.inputs.dropdown.backgroundColor,
        customBackgroundColorHover: theme.reportFormWhite.inputs.dropdown.backgroundColorHover,
        customBorderColor: 'transparent',
        customBorderColorHover: 'transparent',
        customScrollColor: theme.reportFormWhite.inputs.dropdown.scroll,
        customShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
    }); }, [theme]);
    var options = [
        { label: t('reports.reasons.other'), value: 0 },
        { label: t('reports.reasons.spam'), value: 1 },
        { label: t('reports.reasons.breakRules'), value: 2 },
        { label: t('reports.reasons.notThisPerson'), value: 3 },
        { label: t('reports.reasons.adultContent'), value: 4 },
        { label: t('reports.reasons.childPornograpy'), value: 5 },
        { label: t('reports.reasons.drugAdvocacy'), value: 6 },
        { label: t('reports.reasons.violence'), value: 7 },
        { label: t('reports.reasons.animalAbuse'), value: 8 },
        { label: t('reports.reasons.misleadingInformation'), value: 9 },
        { label: t('reports.reasons.fraud'), value: 10 },
        { label: t('reports.reasons.extremism'), value: 11 },
        { label: t('reports.reasons.copiedContent'), value: 12 },
        { label: t('reports.reasons.translation'), value: 13 },
    ];
    return (React.createElement(ReportWrapper, null,
        React.createElement(FlexBox, { width: '100%', direction: 'column', directionMobile: 'column' },
            React.createElement(FlexBox, { direction: 'column', directionMobile: 'column', offsetBottom: 32, offsetBottomMobile: 24 },
                React.createElement(ReportFieldLabel, { offsetBottom: 16, offsetBottomMobile: 8 }, t('reports.reason')),
                React.createElement(UInput.Dropdown, { custom: custom, isSearchable: false, options: options, defaultValue: reasonType, onChange: function (e) { return setReasonType(e.value); }, placeholder: t('reports.reason_placeholder') })),
            React.createElement(FlexBox, { direction: 'column', directionMobile: 'column', offsetBottom: 32, offsetBottomMobile: 24 },
                React.createElement(ReportFieldLabel, { offsetBottom: 16, offsetBottomMobile: 8 }, t('reports.comment')),
                React.createElement(ReportTextarea, { rows: 5, onChange: function (value) { return setComment(value.target.value); }, value: comment })),
            React.createElement(ButtonWrapper, { justify: 'end', offsetBottom: 0, offsetBottomMobile: 0 },
                React.createElement(FlexBox, { widthMobile: "100%", justifyMobile: is744BP ? 'start' : 'end' },
                    React.createElement(ReportButton, { onClick: onClickHandler, disabled: disabled || reasonType < 0 || reasonType > 13 }, t('reports.button_send')))))));
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;
//# sourceMappingURL=ReportModal.js.mapvar __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { FC, useState, useMemo } from "react";
import { Input } from '@brg/input';
import { Button, FlexBox, Fonts, useBreakpoint, useToasts } from '@brg/ui';
import { ComplaintAPI } from '@brg/api';
import styled, { useTheme } from 'styled-components';
import useLocalization from "../../../hooks/useLocalization";
import { ApplicationShared, useAssociatedProfile } from "@brg/auth";
import { UInput } from "../../inputs";
import { LayoutConst } from "../../../core/modules/layout.module";
export var ReportWrapper = styled(FlexBox)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    width: 564px;\n    margin: 0 auto 134px auto;\n    justify-content: space-between;\n\n  @media (max-width: ", "px) {\n    width: calc(100% - 72px);\n    margin: 64px 36px 0;\n  }\n  @media (max-width: ", "px) {\n    width: calc(100% - 32px);\n    margin: 32px 16px 0;\n  }\n"], ["\n    width: 564px;\n    margin: 0 auto 134px auto;\n    justify-content: space-between;\n\n  @media (max-width: ", "px) {\n    width: calc(100% - 72px);\n    margin: 64px 36px 0;\n  }\n  @media (max-width: ", "px) {\n    width: calc(100% - 32px);\n    margin: 32px 16px 0;\n  }\n"])), LayoutConst.screen.md, LayoutConst.screen.s);
export var ButtonWrapper = styled(FlexBox)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\n  @media (max-width: ", "px) {\n    width: 100%;\n  }\n  \n  @media (max-width: ", "px) {\n    position: absolute;\n    bottom: 16px;\n  }\n"], ["\n\n  @media (max-width: ", "px) {\n    width: 100%;\n  }\n  \n  @media (max-width: ", "px) {\n    position: absolute;\n    bottom: 16px;\n  }\n"])), LayoutConst.screen.md, LayoutConst.screen.s);
export var ReportTitle = styled(FlexBox)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    ", ";\n    color: ", ";\n"], ["\n    ", ";\n    color: ", ";\n"])), Fonts.Inter.sectionTitle, function (p) { return p.theme.reportFormWhite.text; });
export var ReportFieldLabel = styled(FlexBox)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    ", ";\n    font-size: 17px;\n    line-height: 22px;\n    letter-spacing: -0.02em;\n    color: ", ";\n    font-weight: 400;\n  \n    @media (max-width: ", "px) {\n      font-size: 13px;\n      line-height: 16px;\n      letter-spacing: normal;\n    }\n"], ["\n    ", ";\n    font-size: 17px;\n    line-height: 22px;\n    letter-spacing: -0.02em;\n    color: ", ";\n    font-weight: 400;\n  \n    @media (max-width: ", "px) {\n      font-size: 13px;\n      line-height: 16px;\n      letter-spacing: normal;\n    }\n"])), Fonts.Inter.smallText, function (p) { return p.theme.reportFormWhite.text; }, LayoutConst.screen.s);
var ReportButton = styled(Button.YellowMedium)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  \n    background: ", "!important;\n    color: ", "!important;\n    border: none!important;\n    border-radius: 3px!important;\n  \n    &:disabled {\n      background: ", "!important;\n      color: ", "!important;\n      border: none!important;\n    }\n\n  @media (max-width: ", "px) {\n    width: calc(100vw - 32px);\n  }\n"], ["\n  \n    background: ", "!important;\n    color: ", "!important;\n    border: none!important;\n    border-radius: 3px!important;\n  \n    &:disabled {\n      background: ", "!important;\n      color: ", "!important;\n      border: none!important;\n    }\n\n  @media (max-width: ", "px) {\n    width: calc(100vw - 32px);\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.reportFormWhite.btns.submit.bg;
}, function (_a) {
    var theme = _a.theme;
    return theme.reportFormWhite.btns.submit.color;
}, function (_a) {
    var theme = _a.theme;
    return theme.reportFormWhite.btns.submit.disabledBg;
}, function (_a) {
    var theme = _a.theme;
    return theme.reportFormWhite.btns.submit.disabledColor;
}, LayoutConst.screen.s);
var ReportTextarea = styled(Input.Textarea)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  background-color: ", ";\n  border-color: ", ";\n  border: none!important;\n  color: ", ";\n  height: 200px!important;\n  \n  &:focus {\n    border: none!important;\n  }\n\n  ::-webkit-scrollbar {\n    width: 3px; /* \u0448\u0438\u0440\u0438\u043D\u0430 scrollbar */\n    height: 3px;\n  }\n  ::-webkit-scrollbar-track {\n    background: ", "; /* \u0446\u0432\u0435\u0442 \u0434\u043E\u0440\u043E\u0436\u043A\u0438 */\n  }\n  ::-webkit-scrollbar-thumb {\n    border-radius: 310px; /* \u0437\u0430\u043A\u0440\u0443\u0433\u043B\u0435\u043D\u0438\u044F \u043F\u043B\u0430\u0448\u043A\u0438 */\n    background: ", ";\n  }\n"], ["\n  background-color: ", ";\n  border-color: ", ";\n  border: none!important;\n  color: ", ";\n  height: 200px!important;\n  \n  &:focus {\n    border: none!important;\n  }\n\n  ::-webkit-scrollbar {\n    width: 3px; /* \u0448\u0438\u0440\u0438\u043D\u0430 scrollbar */\n    height: 3px;\n  }\n  ::-webkit-scrollbar-track {\n    background: ", "; /* \u0446\u0432\u0435\u0442 \u0434\u043E\u0440\u043E\u0436\u043A\u0438 */\n  }\n  ::-webkit-scrollbar-thumb {\n    border-radius: 310px; /* \u0437\u0430\u043A\u0440\u0443\u0433\u043B\u0435\u043D\u0438\u044F \u043F\u043B\u0430\u0448\u043A\u0438 */\n    background: ", ";\n  }\n"
    /**
     * **ReportForm** - форма отправки жалобы
     *
     * @param props
     */
])), function (_a) {
    var theme = _a.theme;
    return theme.reportFormWhite.inputs.backgroundColor;
}, function (_a) {
    var theme = _a.theme;
    return theme.reportFormWhite.inputs.borderColor;
}, function (_a) {
    var theme = _a.theme;
    return theme.reportFormWhite.inputs.color;
}, function (_a) {
    var theme = _a.theme;
    return theme.reportFormWhite.inputs.backgroundColor;
}, function (_a) {
    var theme = _a.theme;
    return theme.reportFormWhite.scroll;
});
/**
 * **ReportForm** - форма отправки жалобы
 *
 * @param props
 */
export var ReportForm = function (props) {
    var t = useLocalization().t;
    var theme = useTheme();
    var handleClose = props.handleClose, entityId = props.entityId, entityType = props.entityType;
    var _a = useState(-1), reasonType = _a[0], setReasonType = _a[1];
    var _b = useState(""), comment = _b[0], setComment = _b[1];
    var _c = useState(false), disabled = _c[0], setDisabled = _c[1];
    var profile = useAssociatedProfile();
    var is744BP = useBreakpoint(LayoutConst.screen.s);
    var toasts = useToasts();
    var onClickHandler = function (ev) { return __awaiter(void 0, void 0, void 0, function () {
        var error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (reasonType < 0 || reasonType > 13)
                        return [2 /*return*/];
                    setDisabled(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, ComplaintAPI.DoReport({
                            authorId: profile === null || profile === void 0 ? void 0 : profile.accountId,
                            target: {
                                entityId: entityId,
                                entityType: entityType,
                                service: ApplicationShared.application,
                            },
                            info: comment,
                            reason: reasonType
                        })];
                case 2:
                    _a.sent();
                    toasts.info(t('reports.report_success'));
                    if (handleClose)
                        handleClose();
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _a.sent();
                    toasts.error(t('reports.report_error'));
                    console.error(error_1);
                    setDisabled(false);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var custom = useMemo(function () { return ({
        customTextColor: theme.reportFormWhite.text,
        customPlaceholderColor: theme.reportFormWhite.text,
        customBackgroundColor: theme.reportFormWhite.inputs.dropdown.backgroundColor,
        customBackgroundColorHover: theme.reportFormWhite.inputs.dropdown.backgroundColorHover,
        customBorderColor: 'transparent',
        customBorderColorHover: 'transparent',
        customScrollColor: theme.reportFormWhite.inputs.dropdown.scroll,
        customShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
    }); }, [theme]);
    var options = [
        { label: t('reports.reasons.other'), value: 0 },
        { label: t('reports.reasons.spam'), value: 1 },
        { label: t('reports.reasons.breakRules'), value: 2 },
        { label: t('reports.reasons.notThisPerson'), value: 3 },
        { label: t('reports.reasons.adultContent'), value: 4 },
        { label: t('reports.reasons.childPornograpy'), value: 5 },
        { label: t('reports.reasons.drugAdvocacy'), value: 6 },
        { label: t('reports.reasons.violence'), value: 7 },
        { label: t('reports.reasons.animalAbuse'), value: 8 },
        { label: t('reports.reasons.misleadingInformation'), value: 9 },
        { label: t('reports.reasons.fraud'), value: 10 },
        { label: t('reports.reasons.extremism'), value: 11 },
        { label: t('reports.reasons.copiedContent'), value: 12 },
        { label: t('reports.reasons.translation'), value: 13 },
    ];
    return (React.createElement(ReportWrapper, null,
        React.createElement(FlexBox, { width: '100%', direction: 'column', directionMobile: 'column' },
            React.createElement(FlexBox, { direction: 'column', directionMobile: 'column', offsetBottom: 32, offsetBottomMobile: 24 },
                React.createElement(ReportFieldLabel, { offsetBottom: 16, offsetBottomMobile: 8 }, t('reports.reason')),
                React.createElement(UInput.Dropdown, { custom: custom, isSearchable: false, options: options, defaultValue: reasonType, onChange: function (e) { return setReasonType(e.value); }, placeholder: t('reports.reason_placeholder') })),
            React.createElement(FlexBox, { direction: 'column', directionMobile: 'column', offsetBottom: 32, offsetBottomMobile: 24 },
                React.createElement(ReportFieldLabel, { offsetBottom: 16, offsetBottomMobile: 8 }, t('reports.comment')),
                React.createElement(ReportTextarea, { rows: 5, onChange: function (value) { return setComment(value.target.value); }, value: comment })),
            React.createElement(ButtonWrapper, { justify: 'end', offsetBottom: 0, offsetBottomMobile: 0 },
                React.createElement(FlexBox, { widthMobile: "100%", justifyMobile: is744BP ? 'start' : 'end' },
                    React.createElement(ReportButton, { onClick: onClickHandler, disabled: disabled || reasonType < 0 || reasonType > 13 }, t('reports.button_send')))))));
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;
//# sourceMappingURL=ReportModal.js.map